import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles, Modal, Theme } from '@material-ui/core';
import { getUnbilledAlertList } from '../../apicalls/invoices';
import { Redirect } from 'react-router-dom';
import { TUnbilledAlert } from './type/Type';
import { AleartModal } from './AleartModal';
import { useRecoilState } from 'recoil';
import { isSortValue, unbilledAlerts } from '../../GlobalState';

type TProps = {
  setErrorMessage: any;
  setOpenError: any;
};

export const BillingAlerts: React.FC<TProps> = (props: TProps) => {
  const { setErrorMessage, setOpenError } = props;

  const classes = useStyles();

  const [alertList, setAlertList] = useRecoilState(unbilledAlerts);

  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    getUnbilledAlerts(setAlertList);
  }, []);

  return (
    <>
      {alertList && alertList.length > 0 && (
        <>
          <div
            className={classes.alertWapper}
            onClick={() => setOpenModal(true)}
          >
            <div className={classes.alert}>(!)未発行の請求書があります。</div>
          </div>
          <AleartModal
            openModal={openModal}
            setOpenModal={setOpenModal}
            alertList={alertList}
            setErrorMessage={setErrorMessage}
            setOpenError={setOpenError}
            getUnbilledAlerts={() => getUnbilledAlerts(setAlertList)}
          />
        </>
      )}
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    alertWapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    alert: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#FFF',
      color: 'red',
      height: 'auto',
      border: 'solid 1px red',
      padding: '0 50px'
    }
  })
);

export const getUnbilledAlerts = async (setAlertList: any) => {
  getUnbilledAlertList().then(data => {
    if (data === 'Not logged in!') {
      <Redirect to='/' />;
    } else {
      if (typeof data === 'string') {
        console.log(data);
      } else {
        if (data.error) {
          console.log(data.error);
        } else {
          setAlertList(data.data);
        }
      }
    }
  });
};
